import React from 'react';
import { CreateProps } from '../../types/utils/CreateProps';
import Div from '../Element/Div/Div';
import { ArrayElementType } from '../../types/utils/ArrayElementType';
import { BorderRadiusProps } from '../../components/Element/getBorderRadiusClasses';
import styles from './Skeleton.module.scss';

type SkeletonProps = CreateProps<
  {
    /** Width can be one of supported sizes from xxxs to xxlg or number as Pixel */
    width?: number | SupportedSkeletonSize;
    /** Height can be one of supported sizes from xxxs to xxlg or number as Pixel  */
    height?: number | SupportedSkeletonSize;
    /** Width in percentages */
    widthInPercentages?: number;
    /** Height in percentages */
    heightInPercentages?: number;
    /** Check Div story for more details */
    borderRadius?: BorderRadiusProps;
  },
  typeof Div
>;

let style;
let classNames;

const Skeleton: React.FunctionComponent<SkeletonProps> = ({
  width = null,
  widthInPercentages = null,
  height = 50,
  heightInPercentages = null,
  className,
  borderRadius = { size: 'sm' },
  ...props
}) => {
  /* istanbul ignore next */
  style = {
    width: width ? `${width}px` : undefined,
    height: height ? `${height}px` : undefined,
  };

  classNames = [className, styles.skeleton];

  if (widthInPercentages) {
    style.width = `${widthInPercentages}%`;
  }

  if (heightInPercentages) {
    style.height = `${heightInPercentages}%`;
  }

  if (typeof width === 'string') {
    classNames.push(styles[`skeleton__width__${width}`]);
    delete style.width;
  }

  if (typeof height === 'string') {
    classNames.push(styles[`skeleton__height__${height}`]);

    delete style.height;
  }

  return (
    <Div
      className={classNames}
      style={style}
      borderRadius={borderRadius as BorderRadiusProps}
      {...props}
    ></Div>
  );
};

const responsiveSupportedSizes = [
  'xxxs',
  'xxs',
  'xs',
  'sm',
  'md',
  'lg',
  'xlg',
] as const;

export type SupportedSkeletonSize = ArrayElementType<
  typeof responsiveSupportedSizes
>;

export default Skeleton;
